import { createFileRoute, Outlet } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
  scope: z.enum(['channel', 'end_users', 'all']).optional().default('channel'),
  type: z.enum(['reseller', 'distributor', 'end_user']).optional(),
  sub_type: z.enum(['direct', 'through_distribution', 'both']).optional(),
state: z.string().optional(),
  country: z.string().optional(),
  search: z.string().optional(),
  show_inactive: z.boolean().optional(),
  sort_by: z.string().optional().default('name'),
  sort_dir: z.enum(['asc', 'desc']).optional().default('asc'),
  view: z.string().optional(),
})

export const Route = createFileRoute('/_authed/accounts')({
  validateSearch: searchSchema,
  component: () => <Outlet />,
})
